export default {
  "Audio Compressor": "오디오 압축하기",
  "HitPaw Online Audio Compressor": "HitPaw 온라인 오디오 압축기",
  "Reduce audio file size online without quality loss.": "품질 손실 없이 온라인으로 오디오 파일 크기를 줄입니다.",
  "Compress": "압축하기",
  "Compressing": "압축중입니다.",
  "Compressed Successfully": "압축되었습니다.",
  "Compress New": "새로 압축하기",
  "Compression is complete": "압축이 완료되었습니다.",
  "Compression failed": "압축에 실패했습니다.",
  "Quality": "품질",
  "Format": "형식",
  "Add file": "파일 추가",
  "Output Settings": "출력 설정",

};
